/** See `src/i18n/locales/en/communications.ts`. */
export const communications = {
  page: {
    title: 'Communicatie',
    lead: 'Stel notificaties op en plan ze in voor {{company}}.',
    noScope: 'Selecteer een bedrijf om de communicatie te zien.',
    forbidden: 'Je mag de communicatie van dit bedrijf niet zien.',
  },
  composer: {
    title: 'Nieuwe notificatie',
    titleField: 'Titel',
    message: 'Bericht',
    category: 'Categorie',
    audience: 'Doelgroep',
    date: 'Datum',
    time: 'Tijd',
    callToAction: 'Call-to-action',
    quietHours: 'Respecteer stille uren',
    quietHoursHint: 'Bezorging buiten 08:00–20:00 uur uitstellen.',
    submit: 'Opslaan als concept',
    schedule: 'Inplannen',
    send: 'Nu verzenden',
  },
  categories: {
    algemeen: 'Algemeen',
    veiligheid: 'Veiligheid',
    evenement: 'Evenement',
    vitaliteit: 'Vitaliteit',
    hr: 'HR',
  },
  audiences: {
    iedereen: 'Iedereen',
    management: 'Management',
    per_afdeling: 'Per afdeling',
    per_locatie: 'Per locatie',
  },
  status: {
    concept: 'Concept',
    ingepland: 'Ingepland',
    verzonden: 'Verzonden',
  },
  log: {
    title: 'Verzendlog',
    empty: 'Nog geen communicatie.',
    columns: {
      message: 'Bericht',
      category: 'Categorie',
      reach: 'Bereik',
      openRate: 'Openpercentage',
      status: 'Status',
    },
  },
  actions: {
    new: 'Nieuwe notificatie',
    cancel: 'Annuleren',
    markScheduled: 'Markeer als ingepland',
    markSent: 'Markeer als verzonden',
  },
} as const;
